.spinner {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

:global(body.amDraggingNDroppingGiveCursor) * {cursor: grab !important; }
:global(body.amDraggingNDroppingGiveCursor) {cursor: grab !important; }